@if (paths.length <= 3) {
  <ng-container
    *ngTemplateOutlet="expandedPaths; context: { $implicit: paths }"
  ></ng-container>
} @else {
  <div class="d-flex align-items-center">
    <ng-container
      *ngTemplateOutlet="
        dropdownPaths;
        context: { $implicit: paths.slice(0, -2) }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        expandedPaths;
        context: { $implicit: paths.slice(-2) }
      "
    ></ng-container>
  </div>
}

<ng-template #expandedPaths let-expandedPaths>
  <div class="d-flex">
    @for (path of expandedPaths; track path; let index = $index) {
      <div class="d-flex">
        <span
          class="folder-name fs-base-l4"
          (click)="onclickPath(path, index)"
          >{{ currentLang === 'th' ? path.name : path.name_en }}</span
        >
        @if (index !== expandedPaths.length - 1) {
          <span class="px-1">
            <svg height="16" stroke="currentColor" width="16">
              <use
                height="16"
                width="16"
                href="assets/images/icons/arrows/chevron-right.svg#chevron-right"
              ></use>
            </svg>
          </span>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #dropdownPaths let-dropdownPaths>
  <div
    class="custom-dropdown"
    dropdownClass="dropdown-std"
    ngbDropdown
    [container]="'body'"
  >
    <div
      class="d-flex align-items-center justify-content-center pointer"
      id="dropdownMoreAction"
      ngbDropdownToggle
    >
      <span class="fal fa-ellipsis-h fa-lg text-gray-pantone"></span>
    </div>
    <div
      class="dropdown-menu"
      aria-labelledby="dropdownMoreAction"
      ngbDropdownMenu
    >
      @for (path of dropdownPaths; track path) {
        <button
          class="d-flex align-items-center"
          ngbDropdownItem
          title="{{
            currentLang === 'th' ? path.name : path.name_en
          }}"
          type="button"
          (click)="onclickPath(path, 0)"
        >
          <svg width="16" height="16" stroke="currentColor">
            <use
              height="16"
              width="16"
              href="/assets/images/icons/files/folder.svg#folder"
            ></use>
          </svg>
          <span class="ms-2 fs-base-l4">{{
            currentLang === 'th' ? path.name : path.name_en
          }}</span>
        </button>
      }
    </div>
  </div>
  <span class="px-1">
    <svg height="16" stroke="currentColor" width="16">
      <use
        height="16"
        width="16"
        href="assets/images/icons/arrows/chevron-right.svg#chevron-right"
      ></use>
    </svg>
  </span>
</ng-template>
